import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff6b6b',
      light: '#ff8e8e',
      dark: '#ff4848',
    },
    secondary: {
      main: '#ffd93d',
      light: '#ffe066',
      dark: '#ffd314',
    },
    text: {
      primary: '#ffe8e8',
      secondary: 'rgba(255, 232, 232, 0.7)',
    },
    background: {
      default: '#2d3436',
      paper: '#404b4d',
    },
    error: {
      main: '#ff4d4d',
    },
    warning: {
      main: '#ffd93d',
    },
    info: {
      main: '#4ecdc4',
    },
    success: {
      main: '#4ecca3',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: '-0.025em',
      fontSize: '2.5rem',
      '@media (min-width:600px)': {
        fontSize: '3.5rem',
      },
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.025em',
      fontSize: '2rem',
      '@media (min-width:600px)': {
        fontSize: '2.75rem',
      },
    },
    h3: {
      fontWeight: 700,
      letterSpacing: '-0.025em',
      fontSize: '1.75rem',
      '@media (min-width:600px)': {
        fontSize: '2.25rem',
      },
    },
    h4: {
      fontWeight: 700,
      fontSize: '1.5rem',
      '@media (min-width:600px)': {
        fontSize: '1.75rem',
      },
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.1rem',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
          '@media (min-width:600px)': {
            padding: '10px 24px',
          },
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: 'none',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '16px',
          '@media (min-width:600px)': {
            padding: '24px',
          },
          '&:last-child': {
            paddingBottom: '16px',
            '@media (min-width:600px)': {
              paddingBottom: '24px',
            },
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '16px',
          paddingRight: '16px',
          '@media (min-width:600px)': {
            paddingLeft: '24px',
            paddingRight: '24px',
          },
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        container: {
          marginTop: '16px',
          marginBottom: '16px',
          '@media (min-width:600px)': {
            marginTop: '24px',
            marginBottom: '24px',
          },
        },
      },
    },
  },
});

export default theme;
